import { useEffect } from 'react';

import { MobileDragModalProps } from './mobile-drag-modal.component';

export const useMobileDragModal = (props: MobileDragModalProps) => {
    useEffect(() => {
        const handleDrag = (event: TouchEvent) => {
            const modal = document.querySelector('.modal-mobile-bottom') as HTMLElement;
            const modalBody = document.querySelector('.modal-body') as HTMLElement;
            if (!modal || (modalBody && modalBody.contains(event.target as Node))) return;

            const touch = event.touches[0];
            const touchY = touch.clientY;

            const newHeight = Math.max(window.innerHeight - touchY, 100);
            modal.style.height = `${newHeight}px`;
        };

        const handleDragEnd = () => {
            const modal = document.querySelector('.modal-mobile-bottom') as HTMLElement;
            if (!modal) return;

            const modalRect = modal.getBoundingClientRect();
            const modalHeight = modalRect.height;
            const originalHeight = window.innerHeight * 0.55;

            if (modalHeight < originalHeight / 2) {
                props.handleClose();
            } else {
                modal.style.height = '';
            }
        };

        const modal = document.getElementById('mobile-drag') as HTMLElement;
        if (modal) {
            modal.addEventListener('touchmove', handleDrag);
            modal.addEventListener('touchend', handleDragEnd);
        }

        return () => {
            if (modal) {
                modal.removeEventListener('touchmove', handleDrag);
                modal.removeEventListener('touchend', handleDragEnd);
            }
        };
    }, []);
};
